import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import axios from 'axios';

// Yahan humne https://likaiev.com set kar diya hai
const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8002'
    : 'https://likaiev.com';

const ProductPortfolio = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/api/products/`);
                setProducts(Array.isArray(response.data) ? response.data : response.data.results || []);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching products:", error);
                setProducts([]);
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const getImageUrl = (product) => {
        const fixUrl = (url) => {
            if (!url) return '/placeholder.jpg';

            // Agar backend se http://66.116.250.115:8002 ya IP wala URL aaye, toh use https://likaiev.com se replace kar denge
            if (url.includes('66.116.250.115:8002') || url.includes('127.0.0.1')) {
                return url.replace(/http:\/\/[^/]+/, BASE_URL);
            }
            if (url.startsWith('http://') || url.startsWith('https://')) {
                return url;
            }
            return `${BASE_URL}${url}`;
        };

        if (product.images && product.images.length > 0) {
            return fixUrl(product.images[0].image);
        }
        if (product.image) {
            return fixUrl(product.image);
        }
        return '/placeholder.jpg';
    };

    if (loading) return <div className="text-center py-20 text-xl font-bold">Loading Products...</div>;

    return (
        <section className="py-16 bg-gray-50">
            <div className="container mx-auto px-4">
                <motion.h2
                    initial={{ opacity: 0, y: -20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12"
                >
                    Product Collection
                </motion.h2>

                {!Array.isArray(products) || products.length === 0 ? (
                    <p className="text-center text-gray-500">No products found in database.</p>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6">
                        {products.slice(0, 5).map((product) => (
                            <div
                                key={product.id}
                                className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200 flex flex-col"
                            >
                                {/* Clean Image Container */}
                                <div className="w-full h-48 bg-gray-100 overflow-hidden">
                                    <img
                                        src={getImageUrl(product)}
                                        alt={product.title}
                                        className="w-full h-full object-cover"
                                    />
                                </div>

                                {/* Content Section */}
                                <div className="p-4 flex flex-col flex-grow justify-between">
                                    <div>
                                        <h3 className="text-base font-bold text-gray-900 mb-2 break-words">
                                            {product.title}
                                        </h3>
                                        <p className="text-gray-600 text-xs sm:text-sm line-clamp-2 mb-4">
                                            {product.description}
                                        </p>
                                    </div>

                                    <Link to={`/products/${product.id}`} className="mt-auto">
                                        <button className="w-full py-2 bg-blue-900 text-white text-xs font-bold rounded-lg hover:bg-orange-600 transition">
                                            Explore More
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {Array.isArray(products) && products.length > 5 && (
                    <div className="text-center mt-12">
                        <Link to="/products">
                            <button className="px-8 py-3 bg-blue-900 text-white text-sm font-bold rounded-full hover:bg-orange-600 transition shadow-lg">
                                View All Products
                            </button>
                        </Link>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ProductPortfolio;